module.exports = __webpack_public_path__ + "img/diagram-2-fill.b19ea735.svg";